import { Tooltip, Typography, Theme } from '@mui/material'
import { SxProps } from '@mui/system'
import { TypogaphyVariantType } from 'c1ui'
import { useEffect, useRef, useState } from 'react'

export type C1TextWithTruncationProps = {
    text: React.ReactNode
    variant?: TypogaphyVariantType
    textStyles?: SxProps<Theme>
    showTooltip?: boolean
}

export const C1TextWithTruncation = ({
    text,
    variant = 'body1',
    showTooltip = true,
    textStyles,
}: C1TextWithTruncationProps): React.ReactElement | null => {
    const [isOverflowed, setIsOverflow] = useState(false)
    const textElementRef = useRef<null | HTMLDivElement>(null)

    useEffect(() => {
        if (!textElementRef.current) {
            return
        }
        setIsOverflow(textElementRef.current.scrollWidth > textElementRef.current.clientWidth)
    }, [])

    return (
        <Tooltip
            title={text}
            disableHoverListener={!showTooltip || !isOverflowed}
            placement="top"
            enterDelay={1000}
        >
            <Typography variant={variant} sx={textStyles} component="div" noWrap ref={textElementRef}>
                {text}
            </Typography>
        </Tooltip>
    )
}
